import callAPiBase from './base';

const segmentationsApi = {
  get: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/segmentationList',
      method: 'GET',
      useToken: true,
      title: 'Segmentations - Get List',
      params,
    }),
  listValues: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/segmentationListValues',
      method: 'GET',
      useToken: true,
      title: 'Segmentations - List Values',
      params,
    }),
  listUsers: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/segmentationListUsers',
      method: 'GET',
      useToken: true,
      title: 'Segmentations - List Users',
      params,
    }),
  create: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/segmentationCreate',
      method: 'POST',
      useToken: true,
      title: 'Segmentations - Create',
      data,
    }),
  update: ({ data }: { data: object }) =>
    callAPiBase({
      endpoint: '/segmentationUpdate',
      method: 'PUT',
      useToken: true,
      title: 'Segmentations - Update',
      data,
    }),
  delete: ({ params }: { params: object }) =>
    callAPiBase({
      endpoint: '/segmentationDelete',
      method: 'DELETE',
      useToken: true,
      title: 'Segmentations - Delete',
      params,
    }),
};

export { segmentationsApi };
export default segmentationsApi;
